import CorvuTooltip, {
  type DynamicProps,
  type TriggerProps,
} from "@corvu/tooltip";
import {
  type JSX,
  Show,
  type ValidComponent,
  mergeProps,
  splitProps,
} from "solid-js";

type TooltipProps<T extends ValidComponent = "button"> = DynamicProps<
  T,
  TriggerProps<T>
> & { content: JSX.Element; withinPortal?: boolean };

export default function Tooltip<T extends ValidComponent = "button">(
  props: TooltipProps<T>,
) {
  const [ours, rest] = splitProps(mergeProps({ withinPortal: true }, props), [
    "content",
    "withinPortal",
  ]);

  const tooltipContent = () => (
    <CorvuTooltip.Content>
      {ours.content}
      <CorvuTooltip.Arrow size={10} />
    </CorvuTooltip.Content>
  );

  return (
    <CorvuTooltip
      placement="top"
      strategy={ours.withinPortal ? "fixed" : "absolute"}
      openDelay={200}
      hoverableContent={false}
      floatingOptions={{
        offset: 10,
        flip: true,
        shift: true,
      }}
    >
      <CorvuTooltip.Trigger {...rest} />
      <Show when={ours.withinPortal} fallback={tooltipContent()}>
        <CorvuTooltip.Portal>{tooltipContent()}</CorvuTooltip.Portal>
      </Show>
    </CorvuTooltip>
  );
}
